import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { mergeWith } from 'lodash-es';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { ChartContainer, ChartContainerProps } from './ChartContainer';
import { defaultPluginsOption } from './constants';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const baseOptions: ChartOptions<'bar'> = {
  responsive: true,
  plugins: { ...defaultPluginsOption },
  scales: {
    y: {
      beginAtZero: true,
    },
  },
};

type ColumnChartProps = Omit<React.ComponentProps<typeof Bar>, 'title'> &
  Pick<ChartContainerProps, 'title'>;

export const ColumnChart = ({
  options,
  title,
  height = '100%',
  ...props
}: ColumnChartProps) => {
  return (
    <ChartContainer title={title}>
      <Bar
        {...props}
        height={height}
        options={mergeWith(baseOptions, options)}
      />
    </ChartContainer>
  );
};
